'use strict'

module.exports = class {
    set(newCommonConfig) {
        self.commonConfig = newCommonConfig
        // TODO invoke listeners (consentPolicy, bsi)
    }
}
